export default "__VITE_ASSET__DAc1u7fl__"